document.addEventListener('DOMContentLoaded', function() {
  const carouselWrapper = document.querySelector('.carousel-wrapper');
  const dots = document.querySelectorAll('.carousel-dot');

  if (carouselWrapper && dots.length) {
    let currentIndex = 0;

    function updateActiveDot(index) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    updateActiveDot(currentIndex);

    carouselWrapper.addEventListener('scroll', function() {
      const scrollPosition = carouselWrapper.scrollLeft;
      const slideWidth = carouselWrapper.clientWidth;
      const newIndex = Math.round(scrollPosition / slideWidth);

      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateActiveDot(currentIndex);
      }
    });
  }
});
